export default __webpack_public_path__ + "static/media/4.b18837c4.jpg";